// extracted by mini-css-extract-plugin
export default {"vertical-align-th-top":"vertical-align-th-top_Mn5FOb4x","replacement-parts__table":"replacement-parts__table_KPj9G5Sr"};